export default __webpack_public_path__ + "static/media/coinBag.a4552abe.jfif";